var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.dialog
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Change document root")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c("p", [
              _vm._v("Document Root for: " + _vm._s(_vm.selectedDomain.domain))
            ]),
            _c("gg-text-field", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                label: "Document Root",
                name: "Document Root",
                "error-messages": _vm.errors.collect("Document Root")
              },
              model: {
                value: _vm.documentRoot,
                callback: function callback($$v) {
                  _vm.documentRoot = $$v
                },
                expression: "documentRoot"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Close")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.changeDocroot
                }
              },
              [_vm._v("Change")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }